import { Component,Inject,OnInit,PLATFORM_ID,Renderer2,TemplateRef,ViewChild } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormGroup } from '@angular/forms';
import { FormBuilder,Validators } from '@angular/forms';
import { MainserviceService } from 'src/app/mainservice.service';
import Swal from 'sweetalert2';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MatDatepicker } from '@angular/material/datepicker';
import { Title, Meta } from '@angular/platform-browser';
import { JsonLdService, SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
@Component({
  selector: 'app-medeicaldevice',
  templateUrl: './medeicaldevice.component.html',
  styleUrls: ['./medeicaldevice.component.scss'],
  providers:[MainserviceService,DatePipe]
})
export class MedeicaldeviceComponent {
  enquiryForm:FormGroup;
  totalcountry:any=[];
  captcha:any
  errorcaptcha:any
  ecaptcha:boolean=false;
  dialcode:any;
  showElement: boolean = false;
  showElementsave: boolean = false;
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  @ViewChild('inputField') inputField!: any;
  currentTime: Date;
  timeSlots:any=[];
  timezone:any;
  appointment_time:boolean=false;
  selectedTime: string | null = null;
  leads:any;
constructor(private ngxsmartservice:NgxSmartModalService,private fb:FormBuilder,private seoService: SeoSocialShareService,private jsonLdService: JsonLdService,
  private mainservice:MainserviceService,private datePipe: DatePipe,private title:Title,private meta:Meta,private renderer: Renderer2,@Inject(PLATFORM_ID) private platformId: Object){
    if (isPlatformBrowser(this.platformId)) {
    this.setSeoMeta();
    this.setSchema();
    this.setFaqSchemaData();
    this.setWebsiteSchema();
    // this.title.setTitle('Revolutionize Your Medical Device Business with Medeil Software');

    // // Add meta tags dynamically
    // this.meta.addTag({ name: 'description', content: 'Optimize operations, increase ROI. Automate processes for success. Streamline operations, maximize efficiency. Start 10 days trial.' });
    // this.meta.addTag({ name: 'keywords', content:  'medical device software, medical software development, medical device software development, software for medical' });
  this.timezone=sessionStorage.getItem('timezone');
  this.enquiryForm=this.fb.group({
      leadname: ['',[ Validators.required]],
      organizationname: ['',[Validators.required]],
      leadsourceid: ['',[]],
      leadsource: ['medeil website',[]],
      sourceRef1: ['',[]],
      sourceRef2: ['',[]],
      description: ['',[ Validators.required]],
      primaryphone: ['',[Validators.required]],
      primaryemail: ['',[Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
      address1: ['',[]],
      address2: ['',[]],
      country: [sessionStorage.getItem('country'),[],[]],
      countryname1: ['0',[]],
      state: [sessionStorage.getItem('state'),[]],
      city: [sessionStorage.getItem('city'),[]],
      enteredcaptcha: ['',[]],
      generatedcaptcha: ['',[]],
      phonedialcode:['',[]],
      checkbox:[false,[]],
      appfrmtime:['',[]],
      apptotime:['',[]],
      appointmentdate:['',[]],
    })
  }
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
    this.mainservice.generatecaptcha();
    this.captcha = localStorage.getItem('captcha')
     // ----country list--
     this.mainservice.getCountryList().subscribe(data=>{
       console.log(data);
       this.totalcountry=data;
     })
    }
  }
  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: 'Medical Device Store Software | Simplify Medical Equipment Retail',
  //     description: 'Manage your medical device store efficiently with Medeil\'s software. Track inventory, sales, and compliance with ease.',
  //     image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.png',
  //     url: 'https://www.medeil.com/medical-device-software',
  //     keywords: 'Medical device store software, medical equipment management, medical inventory software, medical POS system, medical retail software'
  //   };

  //   this.seoService.setData(seoData);
  // }

  // setSchema() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "SoftwareApplication",
  //     "name": "Medical Device Store Software",
  //     "url": "https://www.medeil.com/medical-device-software",
  //     "description": "Manage your medical device store efficiently with Medeil's software. Track inventory, sales, and compliance with ease.",
  //     "applicationCategory": "BusinessApplication",
  //     "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
  //     "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
  //     "offers": {
  //       "@type": "Offer",
  //       "priceCurrency": "USD",
  //       "availability": "https://schema.org/InStock",
  //       "url": "https://www.medeil.com/medical-device-software",
  //       "keywords": "Medical device store software, medical equipment management, medical inventory software, medical POS system, medical retail software"
  //     },
  //     "aggregateRating": {
  //       "@type": "AggregateRating",
  //       "ratingValue": "4.6",
  //       "ratingCount": "8864"
  //     },
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }
  // setWebsiteSchema() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "WebSite",
  //     "name": "Medical Device Store Software",
  //     "url": "https://www.medeil.com",
  //     "description": "Medeil provides advanced pharmacy and healthcare management software solutions. Explore our innovative tools for pharmacies, hospitals, and medical businesses.",
  //     "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
  //     "publisher": {
  //       "@type": "Organization",
  //       "name": "Medeil",
  //       "url": "https://www.medeil.com",
  //       "logo": {
  //         "@type": "ImageObject",
  //         "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
  //       }
  //     },
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }

  // setFaqSchemaData() {
  //   const faqSchema = {
  //     "@context": "https://schema.org",
  //     "@type": "FAQPage",
  //     "mainEntity": [
  //       {
  //         "@type": "Question",
  //         "name": "How is patient data protection and the integration of electronic health records (EHR) handled by your software?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "This inquiry focuses on the software's security and privacy safeguards for patient data as well as its compatibility with EHR systems. In order to guarantee patient care continuity, responses should place a strong emphasis on encryption techniques, safe data transmission protocols, HIPAA compliance, and capabilities for easy connection with EHR platforms."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "What functionalities does your software provide for managing the life cycle of medical devices and filing regulatory reports?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "This inquiry concerns the features of the software that are used to manage the whole medical device lifecycle, from creation and design to production, delivery, and post-market monitoring. In order to expedite time-to-market and simplify compliance procedures, responses should emphasize elements including design controls, risk management, change management, and regulatory submissions management."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "Is it possible for your software to provide the remote maintenance and monitoring of medical devices used in telehealth and remote patient care?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "The software's ability to provide remote medical device monitoring, diagnosis, and maintenance for telehealth and remote patient care applications is the main focus of this question. In order to facilitate virtual consultations and proactive equipment management, responses should emphasize features like remote access, real-time data streaming, predictive maintenance algorithms, and secure communication protocols."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "How is data interchange and interoperability with other medical devices and healthcare IT systems ensured by your software?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "The software's compatibility with medical equipment, other healthcare IT systems, and interoperability standards like HL7 and DICOM is the subject of this inquiry. In order to provide smooth data interchange and interoperability within the healthcare ecosystem, responses should outline integration capabilities, support for standardized data formats, APIs (Application Programming Interfaces), and interoperability certifications."
  //         }
  //       }
  //     ]
  //   };

  //   this.addJsonLdToHead(faqSchema);
  // }
  setSeoMeta() {
 const supportedLanguages = ['en', 'fr', 'es', 'pt'];
      let finalUrl = '';

      if (isPlatformBrowser(this.platformId)) {
        const origin = window.location.origin;
        const path = window.location.pathname;
        const parts = path.split('/');

        let lang = 'en'; // Default
        if (supportedLanguages.includes(parts[1])) {
          lang = parts[1];
        }

        // const fullPath = path.replace(/^\/[a-z]{2}/, '');
        // finalUrl = `${origin}/${lang}${fullPath}`;
        const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

      }

    const seoData = {
      title: 'Medical Device Store Software | Simplify Medical Equipment Retail',
      description:`Manage your medical device store efficiently with Medeil's software. Track inventory, sales, and compliance with ease.`,
      image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.png',
      url: finalUrl,
      keywords: 'Medical device store software, medical equipment management, medical inventory software, medical POS system, medical retail software'
    };

    this.title.setTitle(seoData.title);
    const metaTags = [
      { name: 'description', content: seoData.description },
      { name: 'keywords', content: seoData.keywords },
      { property: 'og:title', content: seoData.title },
      { property: 'og:description', content: seoData.description },
      { property: 'og:url', content: seoData.url },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: seoData.image }
    ];

    metaTags.forEach(tag => this.meta.updateTag(tag));
  }

  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: $localize`:@@MEDICAL_DEVICE_SEO.TITLE:Medical Device Store Software | Simplify Medical Equipment Retail`,
  //     description: $localize`:@@MEDICAL_DEVICE_SEO.DESCRIPTION:Manage your medical device store efficiently with Medeil's software. Track inventory, sales, and compliance with ease.`,
  //     image: 'https://www.medeil.com/assets/img/logo/medeil_logo_1.png',
  //     url: 'https://www.medeil.com/medical-device-software',
  //     keywords: $localize`:@@MEDICAL_DEVICE_SEO.KEYWORDS:Medical device store software, medical equipment management, medical inventory software, medical POS system, medical retail software`
  //   };

  //   this.seoService.setData(seoData);
  // }

  setSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": $localize`:@@MEDICAL_DEVICE_SCHEMA.NAME:Medical Device Store Software`,
      "url": "https://www.medeil.com/medical-device-software",
      "description": $localize`:@@MEDICAL_DEVICE_SCHEMA.DESCRIPTION:Manage your medical device store efficiently with Medeil's software. Track inventory, sales, and compliance with ease.`,
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
      "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
      "offers": {
        "@type": "Offer",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock",
        "url": "https://www.medeil.com/medical-device-software",
        "keywords": $localize`:@@MEDICAL_DEVICE_SCHEMA.KEYWORDS:Medical device store software, medical equipment management, medical inventory software, medical POS system, medical retail software`
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.6",
        "ratingCount": "8864"
      }
    };

    this.jsonLdService.setData(schemaData);
  }

  setWebsiteSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": $localize`:@@MEDICAL_DEVICE_WEBSITE_SCHEMA.NAME:Medical Device Store Software`,
      "url": "https://www.medeil.com",
      "description": $localize`:@@MEDICAL_DEVICE_WEBSITE_SCHEMA.DESCRIPTION:Medeil provides advanced pharmacy and healthcare management software solutions. Explore our innovative tools for pharmacies, hospitals, and medical businesses.`,
      "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
      "publisher": {
        "@type": "Organization",
        "name": "Medeil",
        "url": "https://www.medeil.com",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
        }
      }
    };

    this.jsonLdService.setData(schemaData);
  }

  setFaqSchemaData() {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": $localize`:@@MEDICAL_DEVICE_FAQ.Q1:How is patient data protection and the integration of electronic health records (EHR) handled by your software?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@MEDICAL_DEVICE_FAQ.A1:This inquiry focuses on the software's security and privacy safeguards for patient data as well as its compatibility with EHR systems. In order to guarantee patient care continuity, responses should place a strong emphasis on encryption techniques, safe data transmission protocols, HIPAA compliance, and capabilities for easy connection with EHR platforms.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@MEDICAL_DEVICE_FAQ.Q2:What functionalities does your software provide for managing the life cycle of medical devices and filing regulatory reports?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@MEDICAL_DEVICE_FAQ.A2:This inquiry concerns the features of the software that are used to manage the whole medical device lifecycle, from creation and design to production, delivery, and post-market monitoring.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@MEDICAL_DEVICE_FAQ.Q3:Is it possible for your software to provide the remote maintenance and monitoring of medical devices used in telehealth and remote patient care?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@MEDICAL_DEVICE_FAQ.A3:The software's ability to provide remote medical device monitoring, diagnosis, and maintenance for telehealth and remote patient care applications is the main focus of this question.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@MEDICAL_DEVICE_FAQ.Q4:How is data interchange and interoperability with other medical devices and healthcare IT systems ensured by your software?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@MEDICAL_DEVICE_FAQ.A4:The software's compatibility with medical equipment, other healthcare IT systems, and interoperability standards like HL7 and DICOM is the subject of this inquiry.`
          }
        }
      ]
    };

    this.addJsonLdToHead(faqSchema);
  }


  addJsonLdToHead(schema: any) {
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.id = 'faq-schema';

    // Remove old schema if it exists
    const oldScript = document.getElementById('faq-schema');
    if (oldScript) {
      oldScript.remove();
    }

    this.renderer.appendChild(document.head, script);
  }

  countrychange(){

    this.mainservice.getMobileCode(this.enquiryForm.get('countryname1').value).subscribe((data)=>{
      //console.log(data);
      this.dialcode=data.Dailingcode;
      console.log(this.dialcode);
     // this.registerForm.get('phonedialcode').patchValue(this.dialcode[1]);
    })
  }
  checkCaptcha(){

    var usercaptcha = this.enquiryForm.get('enteredcaptcha').value

    if (this.captcha == usercaptcha) {
      this.ecaptcha = false

    } else {

      this.errorcaptcha = 'Enter correct Captcha'
      this.ecaptcha = true
    }
  }
  generatecaptcha(){
    this.mainservice.generatecaptcha()
    this.captcha = localStorage.getItem('captcha')
  }
  closeModal(): void {
    this.ngxsmartservice.close('enquirypos');
    this.ngxsmartservice.close('appointmentform');
    this.enquiryForm.reset();

    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  }
  validation(){
    let name=this.enquiryForm.get('leadname').value
    let organizationname=this.enquiryForm.get('organizationname').value
    let primaryemail=this.enquiryForm.get('primaryemail').value
    let primaryphone=this.enquiryForm.get('primaryphone').value
    let captcha=this.enquiryForm.get('enteredcaptcha').value
    let checkbox=this.enquiryForm.get('checkbox').value

    // var usercaptcha = this.registerForm.get('enteredcaptcha').value
    if(!name){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!organizationname){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Organization Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryemail){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Email',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryphone){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Mobile Number',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(captcha != this.captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Correct Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(checkbox==false){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Select Accept & Terms condition',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }


    return true
  }
  slectdate(event: any){
    this.showElement=true;
    const selectedDate = event.value;
    const finalDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
    this.enquiryForm.get('appointmentdate').setValue(finalDate);
   this.currentTime = new Date();

   let map={
    "timezone":this.timezone,
    "orginaltimezone":this.currentTime
  }
  this.mainservice.gettimeSlots(map).subscribe(data=>{
    this.timeSlots = data[0].map((time:any)=> {
      const [hours, minutes] = time.split(':');
      const hours12 = ((parseInt(hours) + 11) % 12) + 1;
      const ampm = parseInt(hours) < 12 ? 'AM' : 'PM';
      return `${hours12}:${minutes} ${ampm}`;
    });
    this.showElement=false;
    console.log(this.timeSlots);
  })

    this.appointment_time=true;
  }
  selectTime(time: string): void {
    const currentTime = new Date();
    const formattedTime = this.datePipe.transform(currentTime, 'hh:mm:ss a');
    console.log(formattedTime);
    this.selectedTime = time;
    // this.enquiryForm.get('apptotime').setValue(time);
    this.enquiryForm.get('appfrmtime').setValue(time);

  }
  savelead(){
    this.showElementsave=true;



    // if (valid) {

      let phone = this.enquiryForm.get('primaryphone').value

      let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
      this.enquiryForm.get('primaryphone').setValue(mobileno)

       console.log('form',this.enquiryForm.value);

  this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
    this.leads = data
    // console.log("this.leads",this.leads)
    if (data) {
      // this.enquiryForm.reset()
      // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
      this.enquiryForm.reset();
      this.showElementsave=false;
      // this.submitenquery();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Data saved successfully',
        text: 'We will contact you shortly.',
        showConfirmButton: false,
        timer: 4000
      });
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.close('appointmentform');
      this.enquiryForm.reset();
    }
     else{
      this.enquiryForm.get('primaryphone').setValue(phone);
      // this.showElement=false;
    }
    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  })

  }
  appointment(datasource:any){
    this.enquiryForm.get('sourceRef1').setValue(datasource);
    this.ngxsmartservice.open('enquirypos');
    // this.ngxsmartservice.open('appointmentform');
  }
  submitenquery(){
    let valid=this.validation();
    if(valid){
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.open('appointmentform');
      this.picker.open();
      this.inputField.focus();
    }

  }
}
